$(document).on('turbo:load', function() {
  $('#type-filter').on('change', function() {
    const selectedOption = $(this).val().toLowerCase().replace(/\s+/g, "_");
    if (selectedOption === '') {
        location.href = $(location).attr('pathname')
    } else {
        location.href = $(location).attr('pathname') + '?type=' + selectedOption
    }
  })
});
